import axios from "axios";

export default {
    // getAritcles() {
    //     return axios.get(
    //         `http://www.nbd.com.cn/columns/1346/articles_list.json`
    //     );
    // },
    getImgs() {
        return axios.get("http://www.nbd.com.cn/gallery_json?id=400");
    },
    getNews(){
        return axios.get("http://www.nbd.com.cn/columns/1596/articles_list.json?per=40&page_index=1&simple_info=1");
    }
};
